import React from "react";
//    importing css files
import "./welcomeToInfo.css";
export const  WelcomeToInfo =()=> {
    return (
      <React.Fragment>
        <div className="welcome-info-main-div">
          <h1>Welcome to InfoRide</h1>
          {/* <h1>-Admin</h1> */}
        </div>
      </React.Fragment>
    );
  }

